// extracted by css-extract-rspack-plugin
export default {"cls1":"DownloadPackPreview-cls1_zmZ","cls2":"DownloadPackPreview-cls2_Y3k DownloadPackPreview-cls1_zmZ"};